module.exports = __WEBPACK_EXTERNAL_MODULE_300__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ZeroClipboard","commonjs2":"zeroclipboard","commonjs":"zeroclipboard","amd":"zeroclipboard"}
// module id = 300
// module chunks = 0